<template>
  <v-dialog v-model="modalActivo" persistent max-width="360">
    <v-form ref="form1">
      <v-container grid-list-sm text-center>
        <v-card :color="$store.state.sysBackgroundColor">
          <v-card-title>
            <v-layout row wrap>
              <v-flex>
                <h3 class="overline">{{ titulo }}</h3>
                <p class="caption font-weight-light">
                  Ingrese el código de verificación OTP enviado a
                  <br/>
                  <b>{{ subtitulo }}</b>
                </p>
              </v-flex>
            </v-layout>
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs4 offset-xs4 md4 offset-md4>
                <v-otp-input
                  v-model="itemActivo.OTP"
                  type="number"
                  length="2"
                  :disabled="loading"
                  @finish="onFinish"
                ></v-otp-input>
              </v-flex>
              <v-overlay absolute :value="loading">
                <v-progress-circular
                  indeterminate
                  color="primary"
                ></v-progress-circular>
              </v-overlay>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn small text rounded @click="ejecutarAccion('CerrarLoginOTP')">
              Cancelar
              <v-icon right>clear</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
        <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="2000">
          {{ text }}
        </v-snackbar>
      </v-container>
    </v-form>
  </v-dialog>
</template>

<script>
export default {
  name: "ModalLoginOTP",
  props: {
    activo: Boolean,
    subtitulo: String,
    expectedOTP: String
  },
  data() {
    return {
      titulo: "Autenticación 2FA",
      itemVacio: {
        OTP: ""
      },
      itemActivo: {},
      modalActivo: false,
      loading: false,
      snackbar: false,
      snackbarColor: "default",
      text: "",
      rules: {
        requerido: v => !!v || "Requerido"
      }
    };
  },
  watch: {
    activo() {
      this.modalActivo = this.activo;
      this.inicializar();
    }
  },
  created() {
    this.inicializar();
  },
  methods: {
    inicializar() {
      this.itemActivo = Object.assign({}, this.itemVacio);
    },
    onFinish(rsp) {
      this.loading = true;
      if (rsp === this.expectedOTP) {
        this.snackbarColor = "success";
        this.text = `Código "${rsp}" procesado con éxito`;
      } else {
        this.snackbarColor = "error";
        this.text = `Código "${rsp}" incorrecto`;
      }
      this.snackbar = true;
      setTimeout(() => {
        this.loading = false;
        if (rsp === this.expectedOTP)
          this.ejecutarAccion("AceptarLoginOTP");
        else
          this.ejecutarAccion("CerrarLoginOTP");
        this.snackbar = true;
      }, 1500);
    },
    ejecutarAccion(accion) {
      this.$emit("ejecutarAccion", accion, null);
    }
  }
};
</script>
